import { create } from "zustand"

interface BatchDownloadState {
  isDownloading: boolean
  progress: number
  currentFile: string
  totalFiles: number
  downloadedFiles: number

  setIsDownloading: (downloading: boolean) => void
  setProgress: (progress: number) => void
  setCurrentFile: (filename: string) => void
  setTotalFiles: (total: number) => void
  setDownloadedFiles: (count: number) => void
  reset: () => void
}

export const useBatchDownloadStore = create<BatchDownloadState>((set) => ({
  isDownloading: false,
  progress: 0,
  currentFile: "",
  totalFiles: 0,
  downloadedFiles: 0,

  setIsDownloading: (downloading) => set({ isDownloading: downloading }),
  setProgress: (progress) => set({ progress }),
  setCurrentFile: (filename) => set({ currentFile: filename }),
  setTotalFiles: (total) => set({ totalFiles: total }),
  setDownloadedFiles: (count) => set({ downloadedFiles: count }),
  reset: () => set({ isDownloading: false, progress: 0, currentFile: "", totalFiles: 0, downloadedFiles: 0 }),
}))
